<template>

    <div class="layout__padding-clear layout__width-70 text__align-center">
        <div class="layout__margin-60-0 layout__overflow-hidden">

            <img class="layout__padding-20-0 layout__width-200px"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/spinningAcres/spinning-acres.png">

            <p class="text__colour-white layout__padding-20-0">Design Studio</p>

            <div class="text__size-36 text__colour-white">Pickard Properties | Spinning Acres</div>

            <hr>

            <p class="text__line-height-30px text__colour-white">
                Ravensworth was approached by Pickard Properties to develop a bespoke, luxury brand for a private rental
                scheme in Far Headingley, Leeds. The brand developed as an homage to the area’s rich heritage in the
                textile industry, as well as providing a rustic, lived-in feel that evoked the comfort of home. This was
                complemented by a full suite of interior and exterior CGI, and a package of marketing materials to
                promote the properties to prospective tenants.
            </p>

            <hr>

            <el-button class="button-red layout__width-200px"
                       v-on:click="showcase()">Back to our work
            </el-button>


            <div class="layout__overflow-hidden layout__margin-40-0">
                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/spinningAcres/spinning-acres-case-study-.jpg">

                <div class="layout__padding-20-0 text__size-30 text__colour-white">
                    A luxury brand for a unique, private rental development in Far Headingley, based upon the rich
                    industrial heritage of the area.

                </div>

                <p class="text__colour-white layout__padding-20-0">Mission Statement</p>

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/spinningAcres/spinning-acres-devices.png">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/spinningAcres/spinning-acres-case-study-2.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/spinningAcres/spinning-acres-case-study-3.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/spinningAcres/spinning-acres-case-study-5.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/spinningAcres/spinning-acres-case-study-4-.jpg">

                <img class="layout__width-100 layout__padding-20-0"
                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/studio/ourWork/spinningAcres/spinning-acres-case-study-6-.jpg">
            </div>


        </div>
    </div>

</template>

<script>
    import Router from '../../../router';
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: "landnewhomes",
        props: {},
        components: {
            Carousel,
            Slide
        },
        mixins: [],
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            print() {
                Router.push({
                    name: '/products/print'
                });
            },
            digital() {
                Router.push({
                    name: '/products/print'
                });
            },
            showcase(page) {
                Router.push({
                    name: '/services/design-studio/our-work',
                    query: {
                        client: page,
                    }
                });
            }
        },
    };
</script>